export default "__VITE_ASSET__CM$MbxwW__"